<template>
  <div class="box">
    <div class="right-box">
      <div class="head-box">
        <h4>{{ renderText(type) }}</h4>
        <div class="c-flex">
          <el-input
            placeholder="请输入标题进行搜索"
            v-model="searchValue"
            clearable
            @clear="
              fpi.page = 1;
              getData();
            "
            @keyup.enter.native="
              fpi.page = 1;
              getData();
            "
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click.native="
                fpi.page = 1;
                getData();
              "
            ></el-button>
          </el-input>
          <el-button type="primary" class="c-m-l-10" @click.native="noticeAdd">
            新增
          </el-button>
          <el-button class="c-m-l-10" @click.native="removeList">批量删除</el-button>
        </div>
      </div>
      <div class="content-box">
        <div class="content-table">
          <el-table
            ref="table"
            :data="fpi.data"
            empty-text="暂无信息"
            height="calc(100% - 50px)"
            @selection-change="handleSelectionChange"
            v-if="refresh"
            highlight-current-row
          >
            <el-table-column type="selection" width="55"></el-table-column>

            <el-table-column label="标题" width="280" fixed="left">
              <template slot-scope="scope">
                <el-button type="text" @click.native.prevent="doEdit(scope.row, true)">
                  {{ scope.row.title }}
                </el-button>
                <el-button
                  v-show="scope.row.isTop"
                  type="success"
                  size="mini"
                  class="c-m-l-15"
                  style="padding: 4px 8px"
                >
                  置顶
                </el-button>
              </template>
            </el-table-column>
            <template v-if="type == '4'">
              <el-table-column label="部位" min-width="220px" show-overflow-tooltip>
                <template slot-scope="scope">
                  {{ osg.formatCascadeMultiple('repairParts', scope.row.attribute) }}
                </template>
              </el-table-column>
              <el-table-column label="省" width="100px" show-overflow-tooltip>
                <template slot-scope="scope">
                  {{ formatProvince(Array.isArray(scope.row.area) ? scope.row.area[0] : '') }}
                </template>
              </el-table-column>
              <el-table-column label="市" width="100px" show-overflow-tooltip>
                <template slot-scope="scope">
                  {{ formatCity(Array.isArray(scope.row.area) ? scope.row.area[1] : '') }}
                </template>
              </el-table-column>
              <el-table-column label="区" width="100px" show-overflow-tooltip>
                <template slot-scope="scope">
                  {{ formatDistrict(Array.isArray(scope.row.area) ? scope.row.area[2] : '') }}
                </template>
              </el-table-column>
              <el-table-column
                prop="address"
                label="详细地址"
                min-width="220px"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="exts.supervisorName"
                label="管家"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="exts.name"
                label="客户姓名"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="exts.phone"
                label="客户电话"
                show-overflow-tooltip
                width="140px"
              ></el-table-column>
              <el-table-column
                prop="exts.finishedDateTime"
                label="完工日期"
                show-overflow-tooltip
                width="140px"
              ></el-table-column>
              <el-table-column label="评分" width="150px">
                <template slot-scope="scope">
                  <el-rate
                    v-if="scope.row.exts && scope.row.exts.rate"
                    v-model="scope.row.exts.rate"
                    disabled
                  ></el-rate>
                </template>
              </el-table-column>
              <el-table-column
                prop="exts.areaNum"
                label="施工面积"
                show-overflow-tooltip
              ></el-table-column>
            </template>
            <el-table-column
              prop="createUserName"
              label="创建人"
              show-overflow-tooltip
              min-width="140px"
            ></el-table-column>
            <el-table-column
              prop="exts.chooseApplet"
              label="展示位置"
              show-overflow-tooltip
              min-width="140px"
              :formatter="formatChooseApplet"
            ></el-table-column>
            <el-table-column
              prop="createTime"
              label="创建日期"
              min-width="140px"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              prop="updateTime"
              label="更新日期"
              min-width="140px"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column label="置顶状态" v-if="type == '3'">
              <template slot-scope="scope">
                <el-tag v-if="scope.row.isTop">
                  已置顶
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column fixed="right" width="100px">
              <template slot-scope="scope">
                <el-dropdown>
                  <el-button>
                    操作
                    <i class="el-icon-arrow-down el-icon--right"></i>
                  </el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item @click.native="doEdit(scope.row, false)">
                      编辑
                    </el-dropdown-item>
                    <el-dropdown-item @click.native="doTop(scope.row)">
                      {{ scope.row.isTop ? '取消置顶' : '置顶' }}
                    </el-dropdown-item>
                    <el-dropdown-item @click.native="deleteBtn(scope.row)">
                      删除
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            class="pagination"
            @size-change="pageSizeChange"
            @current-change="pageChange"
            :current-page="fpi.page"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="fpi.rows"
            layout="total, sizes, prev, pager, next, jumper"
            :total="fpi.total"
          ></el-pagination>
        </div>
      </div>
    </div>
    <el-dialog
      :title="`${renderText(type)}`"
      :visible.sync="formDataDialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="800px"
    >
      <el-form
        :model="formData"
        ref="formData"
        :rules="rules"
        label-width="100px"
        label-position="left"
      >
        <template v-if="type == '3' || type == '6'">
          <el-form-item label="标题" prop="title">
            <el-input v-model="formData.title"></el-input>
          </el-form-item>
          <el-form-item label="是否置顶">
            <el-switch
              v-model="formData.isTop"
              active-color="#13ce66"
              :active-value="1"
              :inactive-value="0"
            ></el-switch>
          </el-form-item>
          <el-form-item label="选择展示小程序">
            <el-select v-model="formData.exts.chooseApplet">
              <el-option
                v-for="(item, i) in options.chooseApplet"
                :key="i"
                :label="item.name"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="优惠券">
            <el-select v-model="formData.categoryId">
              <el-option
                v-for="(item, i) in options.vouchers"
                :key="i"
                :label="item.title"
                :value="item._id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="小程序路径">
            <el-input v-model="formData.path"></el-input>
          </el-form-item>
          <el-form-item label="图片">
            <el-upload
              :action="upload.url"
              :data="upload.data"
              :file-list="formData.fileList"
              multiple
              list-type="picture-card"
              :limit="upload.limit"
              :on-exceed="osg.uploadExceed"
              :before-upload="
                file => {
                  return osg.beforeUpload(file, 'image');
                }
              "
              :on-success="
                (response, file, fileList) => {
                  // return osg.uploadSuccess(response, file, fileList, 'image');
                  return (formData.fileList = fileList);
                }
              "
              :on-error="osg.uploadError"
              :on-remove="
                (file, fileList) => {
                  return beforeRemove(file, fileList, 'fileList');
                }
              "
              :on-preview="osg.uploadPreview"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog
              :modal="false"
              custom-class="dialog-img"
              :visible.sync="upload.dialogVisible"
            >
              <img width="100%" :src="upload.dialogImageUrl" alt />
            </el-dialog>
          </el-form-item>
          <c-editor :formData="formData" :value="'content'" ref="editor"></c-editor>
        </template>
        <template v-if="type == '4'">
          <el-form-item label="案例标题" prop="title">
            <el-input v-model="formData.title"></el-input>
          </el-form-item>
          <el-form-item label="是否置顶">
            <el-switch
              v-model="formData.isTop"
              active-color="#13ce66"
              :active-value="1"
              :inactive-value="0"
            ></el-switch>
          </el-form-item>
          <el-form-item label="部位" prop="attribute">
            <el-cascader
              popper-class="cascaderLabelHide-wrapper"
              :ref="'attribute' + 'Cascade'"
              v-model="formData.attribute"
              :options="options['repairParts']"
              :props="{
                multiple: true,
                label: 'name',
                expandTrigger: 'hover',
                checkStrictly: false
              }"
              clearable
            ></el-cascader>
          </el-form-item>
          <el-form-item label="省市区" prop="area">
            <el-cascader
              popper-class="cascaderLabelHide-wrapper"
              ref="areaSelector"
              :options="area.options"
              :props="{
                expandTrigger: 'hover',
                checkStrictly: true
              }"
              v-model="formData.area"
              clearable
            ></el-cascader>
          </el-form-item>
          <el-form-item label="详细地址" prop="address">
            <el-input v-model="formData.address"></el-input>
          </el-form-item>
          <el-form-item label="客户姓名" prop="exts.name">
            <el-input v-model="formData.exts.name"></el-input>
          </el-form-item>
          <el-form-item label="客户电话" prop="exts.phone">
            <el-input v-model="formData.exts.phone"></el-input>
          </el-form-item>
          <el-form-item label="管家" prop="exts.supervisorName">
            <el-input v-model="formData.exts.supervisorName"></el-input>
          </el-form-item>
          <el-form-item label="管家id" prop="exts.supervisorId">
            <el-input v-model="formData.exts.supervisorId"></el-input>
          </el-form-item>
          <el-form-item label="工单id" prop="exts.serviceAppointmentId">
            <el-input v-model="formData.exts.serviceAppointmentId"></el-input>
          </el-form-item>
          <el-form-item label="完工日期" prop="exts.finishedDateTime">
            <el-date-picker
              v-model="formData.exts.finishedDateTime"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetime"
              placeholder="选择日期"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="评分" prop="exts.rate">
            <el-rate v-model="formData.exts.rate"></el-rate>
          </el-form-item>
          <el-form-item label="施工面积" prop="exts.areaNum">
            <el-input v-model="formData.exts.areaNum"></el-input>
          </el-form-item>
          <el-form-item label="施工商品" prop="exts.products">
            <el-input v-model="formData.exts.products"></el-input>
          </el-form-item>
          <el-form-item
            label="案例图片"
            :rules="{
              required: true,
              type: 'array',
              trigger: 'blur',
              message: '案例图片不能为空'
            }"
          >
            <el-upload
              :action="upload.url"
              :data="upload.data"
              :file-list="formData.fileList"
              multiple
              list-type="picture-card"
              :limit="upload.limit"
              :on-exceed="osg.uploadExceed"
              :before-upload="
                file => {
                  return osg.beforeUpload(file, 'image');
                }
              "
              :on-success="
                (response, file, fileList) => {
                  // return osg.uploadSuccess(response, file, fileList, 'image');
                  return (formData.fileList = fileList);
                }
              "
              :on-error="osg.uploadError"
              :on-remove="
                (file, fileList) => {
                  return beforeRemove(file, fileList, 'fileList');
                }
              "
              :on-preview="osg.uploadPreview"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog
              :modal="false"
              custom-class="dialog-img"
              :visible.sync="upload.dialogVisible"
            >
              <img width="100%" :src="upload.dialogImageUrl" alt />
            </el-dialog>
          </el-form-item>
          <el-form-item label="正文" prop="content">
            <c-editor :formData="formData" :value="'content'" ref="editor"></c-editor>
          </el-form-item>
        </template>
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="formDataSave()">确 定</el-button>
        <el-button @click="formDataDialog = false">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :title="renderText(type)"
      id="userShowDialog"
      :visible.sync="showDialog"
      width="800px"
    >
      <div class="showCell">
        <span>标题：</span>
        <span>{{ formData.title }}</span>
      </div>
      <div class="showCell">
        <span>图片：</span>
        <el-image
          style="width: 100px; height: 100px; margin: 5px"
          v-for="(item, index) in formData.fileList"
          :key="index"
          :src="item.url"
          :preview-src-list="[item.url]"
        ></el-image>
      </div>
      <div class="showCell">
        <span>内容：</span>
        <span v-html="formData.content"></span>
      </div>
      <div slot="footer">
        <el-button type="primary" @click="showDialog = false">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// import areajs from '../../resources/js/area.js';
// import areaList from '../../resources/js/areaList.js';
export default {
  activated() {
    window.$this = this;
  },
  name: 'orgUser',
  data() {
    window.$this = this;
    return {
      tenantID: '', //租户id
      activeTab: 'org', //当前激活tab
      orgDialog: false,
      defaultProps: {
        children: 'childrens',
        label: 'name'
      },
      options: {
        cascadeCode_repairParts: { codeId: 'repairParts' },
        cascadeCode_chooseApplet: { codeId: 'chooseApplet' },
        vouchers: []
      },
      formDataDialog: false, //是否显示编辑
      showDialog: false, //展示信息
      searchValue: '', //搜索关键词
      fpi: {}, //问题信息列表
      formData: { exts: { chooseApplet: '' } }, //编辑信息
      edit: false, //新增false 编辑true
      rules: {
        categoryId: [
          {
            required: true,
            message: '分类不能为空',
            trigger: ['blur', 'change']
          }
        ],
        title: [
          {
            required: true,
            message: '不能为空',
            trigger: 'blur'
          }
        ],
        content: [
          {
            required: true,
            message: '内容不能为空',
            trigger: 'blur'
          }
        ]
      },
      delList: [], //批量信息列表
      formatterTypeArr: [], //反显信息表的分类
      // 富文本编辑器
      vqeditor: {
        content: '',
        editorOption: {
          theme: 'snow',
          placeholder: '请输入公告内容',
          modules: {
            //工具栏
            toolbar: [
              ['bold', 'italic', 'underline' /* , 'strike' */], //加粗，斜体，下划线，删除线
              [
                {
                  header: 1
                },
                {
                  header: 2
                }
              ], // 标题，键值对的形式；1、2表示字体大小
              [
                {
                  list: 'ordered'
                },
                {
                  list: 'bullet'
                }
              ], //列表
              [
                {
                  align: []
                }
              ], //对齐方式
              [
                {
                  color: []
                },
                {
                  background: []
                },
                {
                  font: []
                }
              ], // 字体颜色，字体背景颜色，字体
              ['clean'], //清除字体样式
              ['link', 'image' /* ,'video' */] //上传图片、上传视频
            ]
          }
        }
      },
      area: {
        options: this.osg.areaList,
        props: {
          checkStrictly: true,
          expandTrigger: 'hover'
        }
      },
      upload: {
        url: 'http://up-z1.qiniup.com',
        downloadUrl: $this.osg.downloadUrl,
        data: {},
        dialogImageUrl: '',
        dialogVisible: false,
        limit: 5
      },
      type: 0, //企业文档类型 3企业公告 4施工案例 6小程序轮播
      refresh: true
    };
  },
  created() {
    this.type = this.$route.query.type || '3';
  },
  mounted() {
    this.tenantID = JSON.parse(sessionStorage['entity']).tenantId;
    this.osg.codeoption(() => {
      this.osg.getFpi();
      this.getData();
      this.getVouchers();
    });
  },
  methods: {
    //页码变更
    pageSizeChange(pageSize) {
      this.fpi.rows = pageSize;
      this.getData();
    },
    //当前页变更
    pageChange(currentPage) {
      this.fpi.page = currentPage;
      this.getData();
    },
    //获取信息列表
    getData() {
      var params = {
        'regex:title|string#and': this.searchValue,
        'is:type|integer#and': this.type || '3',
        sortField: 'isTop,createTime',
        sortOrder: 'desc',
        page: this.fpi.page,
        rows: this.fpi.rows
      };
      this.osg.setFpi(params);
      this.osg.ajax('document/query.do', params, res => {
        if (res) {
          if (this.type == '4') {
            res.data.map(item => {
              item.exts = item.exts || {};
              item.exts.rate = item.exts.rate ? Number(item.exts.rate) : 0;
            });
          }
          this.fpi = res;
          this.$nextTick(() => {
            this.$refs.table.doLayout();
            this.$forceUpdate();
          });
        }
      });
    },
    getVouchers() {
      this.osg.ajax(
        'biz/voucherDef/query.do',
        {
          _all: '1',
          sortField: 'createTime',
          sortOrder: 'desc'
        },
        res => {
          this.options.vouchers = res.data;
        }
      );
    },
    //添加信息按钮
    noticeAdd() {
      this.edit = false;
      this.formData = { exts: {} };
      this.formDataDialog = true;
    },
    //编辑信息按钮
    doEdit(row, isShow) {
      row.exts = row.exts || {};
      if (this.type == '4') {
        row.exts.rate = row.exts.rate ? Number(row.exts.rate) : 0;
      }

      if (row.fileids && row.fileids.length) {
        row.fileList = row.fileids.map(item => {
          item = this.$util.isJson(item) ? JSON.parse(item) : item;
          if (typeof item == 'string') {
            //item格式为 uuid_要展示的名字.文件扩展名，有_取_后面的，没有返回整个
            let showName = item.indexOf('_') != -1 ? item.substr(item.indexOf('_') + 1) : item;
            return {
              url: this.upload.downloadUrl + item.replace(window.$this.osg.downloadUrl, ''),
              name: showName
            };
          } else {
            //item格式为 uuid_要展示的名字.文件扩展名，有_取_后面的，没有返回整个
            let showName =
              typeof item == 'string'
                ? item.indexOf('_') != -1
                  ? item.substr(item.indexOf('_') + 1)
                  : item
                : '';
            return {
              url: this.upload.downloadUrl + item.url.replace(window.$this.osg.downloadUrl, ''),
              name: showName
            };
          }
        });
      }
      if (isShow) {
        this.formData = this.$util.deepCopy(row);
        this.showDialog = true;
        return;
      }
      this.edit = true;
      this.formData = this.$util.deepCopy(row);
      this.formDataDialog = true;
      console.log(this.formData);
    },
    //置顶按钮
    doTop(row) {
      let formData = row;
      formData.isTop = +!formData.isTop;
      this.osg.ajax('document/upsert.do', formData, res => {
        this.osg.toast('保存成功');
        this.formDataDialog = false;
        this.getData();
      });
    },
    //保存信息
    formDataSave() {
      let pass;
      this.$refs['formData'].validate(valid => {
        if (valid) pass = true;
      });
      if (!pass) return;
      // if (!this.formData.fileList || !this.formData.fileList.length) {
      //   this.osg.toast('至少上传一个图片！', 'error');
      //   return;
      // }
      if (this.formData.fileList && this.formData.fileList.length) {
        this.formData.fileids = this.formData.fileList.map(item => {
          if (item.response) {
            return item.response.key;
          } else if (item.url) {
            let reg = new RegExp(this.upload.downloadUrl, 'g');
            return item.url.replace(reg, '');
          }
        });
      }
      let formData = this.$util.deepCopy(this.formData);
      formData.type = this.type;
      formData.tenantId = this.tenantID;
      formData.isTop = formData.isTop ? formData.isTop : 0;
      delete formData.fileList;
      console.log(formData);
      this.osg.ajax('document/upsert.do', formData, res => {
        this.osg.toast('保存成功');
        this.formDataDialog = false;
        this.getData();
      });
    },
    //删除信息
    deleteBtn(row) {
      this.osg.confirm('是否确认删除 ' + row.title + '？', () => {
        this.osg.ajax(`document/remove/${row._id}.do`, null, res => {
          this.osg.toast('删除成功！');
          this.getData();
        });
      });
    },
    beforeRemove(file, fileList, field) {
      let list = this.formData[field];
      let listIds = this.formData.fileids;
      let reg = new RegExp(this.upload.downloadUrl, 'g');
      let keyStr = '';

      if (file.response) {
        let removeIndex = list.findIndex(item =>
          item.response ? item.response.key == file.response.key : false
        );
        let removeIndexIds = listIds.findIndex(item => item == file.response.key);

        if (removeIndex != -1) list.splice(removeIndex, 1);
        if (removeIndexIds != -1) listIds.splice(removeIndexIds, 1);
      } else if (file.url) {
        keyStr = file.url.replace(reg, '');
        let removeIndex = list.findIndex(item => item.url == file.url);
        let removeIndexIds = listIds.findIndex(item => item == keyStr);
        if (removeIndex != -1) list.splice(removeIndex, 1);
        if (removeIndexIds != -1) listIds.splice(removeIndexIds, 1);
      }
      // if (keyStr) {
      //   this.osg.ajax(`back/super/file/delete/${keyStr}.do`, null, res => {}, {
      //     method: 'GET'
      //   });
      // }
    },
    // beforeRemove(file, fileList, field) {
    //   var list = this.formData[field];
    //   if (!file.response) return;
    //   for (var i = 0; i < list.length; i++) {
    //     if (file.response.key == list[i].response.key) {
    //       list.splice(i, 1);
    //       this.doImgSave();
    //       break;
    //     }
    //   }
    //   this.osg.ajax(
    //     `back/super/file/delete/${file.response.key}.do`,
    //     null,
    //     res => {},
    //     {
    //       method: "GET"
    //     }
    //   );
    // },
    doImgSave() {
      let params = this.$util.deepCopy(this.formData);
      params.image.map(item => {
        if (item.url.indexOf('blob:') != -1) {
          item.url = this.upload.downloadUrl + item.response.key;
        }
      });
      params.image = JSON.stringify(params.image);
      this.$util.saveExtField(this.extFields, params);
    },
    //批量删除
    removeList() {
      if (!this.delList.length) {
        this.osg.toast('请勾选要删除的信息列表！', 'warning');
        return;
      }
      this.osg.confirm('是否确认删除 ？', () => {
        let dataArr = this.delList.map(item => item._id);
        this.osg.ajax('document/batchRemove.do', { dList: JSON.stringify(dataArr) }, res => {
          if (res) {
            this.osg.toast('删除成功！');
            this.getData();
          }
        });
      });
    },
    //被勾选上的问题信息列表
    handleSelectionChange(val) {
      this.delList = val;
    },
    formatterType(row, column, cellValue, index) {
      return this.formatterTypeArr
        .map(item => {
          if (item._id == cellValue) return item.name;
        })
        .join('');
      // var obj = obj1.map((o,index) => ({...o, ...obj2[index]}))
    },
    formatProvince(cellValue) {
      return this.osg.areaObj.province_list[cellValue];
    },
    formatCity(cellValue) {
      return this.osg.areaObj.city_list[cellValue];
    },
    formatDistrict(cellValue) {
      return this.osg.areaObj.county_list[cellValue];
    },

    formatChooseApplet(row, column, cellValue) {
      this.options.chooseApplet.map(item => {
        item.label = item.name;
      });
      return this.osg.codelabel('chooseApplet', cellValue);
    },
    //渲染标题文字
    renderText(type) {
      let title = '';
      switch (type) {
        case '4':
          title = '施工案例';
          break;
        case '6':
          title = '小程序轮播图';
          break;
        default:
          title = '企业公告';
      }
      return title;
    },
    //表格刷新
    Refresh() {
      this.refresh = false;
      this.$nextTick(function() {
        this.refresh = true;
      });
    }
  },
  watch: {
    $route() {
      // window.$this = this;
      this.type = this.$route.query.type || '3';
      // this.osg.getFpi();
      // this.getData();
      this.Refresh();
    },
    'formData.area'() {
      if (this.$refs.areaSelector) {
        this.$refs.areaSelector.dropDownVisible = false; //监听值发生变化就关闭它
      }
    }
  }
};
</script>
<style scoped>
.showCell {
  margin: 0 40px 10px 10px;
  display: flex;
  align-items: center;
}
.showCell > span:nth-of-type(1) {
  width: 80px;
  line-height: 30px;
  display: flex;
  flex-shrink: 0;
  align-items: center;
}
.isShow {
  display: none;
}
.wp {
  position: absolute;
  top: 50%;
  right: 36px;
  transform: translateY(-50%);
}
.el-upload-list--picture-card .el-upload-list__item {
  width: 100px;
  height: 100px;
}
.el-upload--picture-card {
  width: 100px;
  height: 100px;
  line-height: 114px;
}
.el-upload-list__item {
  transition: none !important;
}
</style>
